<template>
  <div id="app">
    <div class="wrapper" v-if="is_register || is_recover || is_reset">
      <router-view />
    </div>
    <div class="wrapper" v-else-if="!is_logged_in" :class="!is_logged_in ? 'login-wrapper' : ''">
      <login />
    </div>
    <div
      class="app"
      :class="{'aside-collapsed': is_aside_collapsed, 'aside-toggled': is_aside_toggled}"
      v-else-if="is_logged_in">
      <div class="wrapper">
        <vue-progress-bar />
        <navbar />
        <sidebar :menu="menu" :submenu="submenu"/>
        <offsidebar />
        <router-view />
        <Footer />
      </div>
    </div>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import Footer from '@/components/Footer.vue'
import Navbar from '@/components/Navbar.vue'
import Offsidebar from '@/components/Offsidebar.vue'
import Sidebar from '@/components/Sidebar.vue'

export default {
  components: {
    Footer,
    login: Login,
    navbar: Navbar,
    offsidebar: Offsidebar,
    sidebar: Sidebar
  },
  data () {
    return {
      menu: null,
      submenu: null
    }
  },
  computed: {
    is_aside_toggled () {
      return this.$store.getters.aside_collapsed === 'yes'
    },
    is_aside_collapsed () {
      return this.$store.getters.aside_collapsed === 'yes'
    },
    is_logged_in () {
      return this.$store.getters.is_logged_in
    },
    is_register () {
      return this.$route.path === '/register'
    },
    is_recover () {
      return this.$route.path === '/recover'
    },
    is_reset () {
      return this.$route.path === '/reset'
    }
  },
  methods: {
    order (order, search, ordering) {
      if (order === ordering) {
        this.$router.push({
          query: {
            search: search,
            ordering: '-' + order,
            page: 1,
            page_size: order.page_size
          }
        })
      } else {
        this.$router.push({
          query: {
            search: search,
            ordering: order,
            page: 1,
            page_size: order.page_size,
          }
        })
      }
    },
    make_search (search, ordering) {
      this.$router.push({
        query: {
          search: search,
          ordering: ordering,
          page: 1
        }
      })
    },
    paginate (page, search, ordering) {
      this.$router.push({
        query: {
          page: page.page,
          search: search,
          ordering: ordering,
          page_size: page.page_size,
        }
      })
    },
    requestTerms() {
      if (this.$store.state.request_terms) {
        this.$modal.show('terms-and-conditions')
      }
    }
  },
  mounted () {
    this.$Progress.finish()   // for App.vue specifically
  },
  created () {
    this.$Progress.start()    // for App.vue specifically

    this.$router.beforeEach((to, from, next) => {
      this.$Progress.start()
      next()
    })
    this.$router.afterEach((to, from) => {
      this.$Progress.finish()
      this.requestTerms()
    })
  }
}
</script>

<style lang="scss">
@import "assets/css/animate.css";
@import "assets/css/bootstrap.css";
@import "assets/css/app.css";
@import "assets/css/loaders.css";
@import "assets/css/theme-b.css";
@import "assets/css/vue-multiselect.min.css";
@import "assets/css/custom.css";
@import "assets/vendor/@fortawesome/fontawesome-free-webfonts/css/fa-brands.css";
@import "assets/vendor/@fortawesome/fontawesome-free-webfonts/css/fa-regular.css";
@import "assets/vendor/@fortawesome/fontawesome-free-webfonts/css/fa-solid.css";
@import "assets/vendor/@fortawesome/fontawesome-free-webfonts/css/fontawesome.css";
@import "assets/vendor/datatables.net-bs4/css/dataTables.bootstrap4.css";
@import "assets/vendor/simple-line-icons/css/simple-line-icons.css";
@import "~noty/src/noty.scss";
@import "~noty/src/themes/bootstrap-v4.scss";
@import "assets/css/vue-datetime.css";
</style>



// WEBPACK FOOTER //
// src/App.vue